import { Link } from 'react-router-dom';
import { ComplianceColorDot } from 'components/common/Tables/Cells/ComplianceColorDot';
import classes from 'components/widgets/SummaryTable/summaryTable.module.scss';
import { ComplianceRangeCell } from 'components/common/Tables/Cells/ComplianceRangeCell';
import { CustomizedTooltip } from 'components/common';
import React from 'react';

const customSortNonCompliant = (rowA, rowB) => {
    const { numFailed: numFailedA } = rowA.original;
    const { numFailed: numFailedB } = rowB.original;
    if (!numFailedA) return 1;
    if (!numFailedB) return -1;
    return numFailedA - numFailedB;
};

export const summaryColumns = (versionId) => [
    {
        Header: 'Category',
        accessor: 'category',
        width: 310,
        Cell: ({ value }) => {
            return <Link to={versionId + '/' + value.replace('/', '_')}>{value}</Link>;
        },
    },
    {
        Header: 'Overall Compliance',
        accessor: 'complianceColor',
        width: 200,
        Cell: ({ value }) => (value === 'NA' ? null : <ComplianceColorDot value={value} />),
    },
    {
        Header: 'Compliance Distribution',
        width: 260,
        id: 'complianceDistribution',
        accessor: (rowOriginal) => {
            const { numFailed, numPassed, numTotal } = rowOriginal;
            return {
                noneCompliant: `${(numFailed / numTotal) * 100}%`,
                compliant: `${(numPassed / numTotal) * 100}%`,
            };
        },

        Cell: ({ value, row }) => {
            const { numFailed, numPassed } = row.original;
            return (
                <div className={classes.complianceRangeContainer}>
                    <ComplianceRangeCell
                        noneCompliant={value.noneCompliant}
                        compliant={value.compliant}
                        failedPercent={numFailed}
                        passedPercent={numPassed}
                    />
                </div>
            );
        },
        sortType: customSortNonCompliant,
    },

    {
        Header: '# Active Checks',
        accessor: 'numTotal',
        width: 160,
    },
    {
        Header: '# Failed',
        accessor: 'numFailed',
        width: 160,
    },
    {
        Header: '# Passed',
        accessor: 'numPassed',
        width: 160,
    },
    {
        Header: 'Score Deduction',
        accessor: 'negativeScoreImpact',
        Cell: ({ value }) => (
            <CustomizedTooltip
                triggerElement={<div className={classes.scoreDeduction}>{value === 0 ? '' : value * -1}</div>}
                tooltipContent={`Sum of score deduction for this category`}
            />
        ),
    },
];
